<ef-loading [loading]="payrateOverrideService.loading$ | async"></ef-loading>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-payrate-override
    [items]="items$ | async"
    [payrollItemsSelectItems]="payrollItemsSelectItems$ | async"
    [payrollItemsFilterSelectItems]="PayrollItemSubject.asObservable() | async"
    [payrollItemTypesFilterSelectItems]="PayrollItemTypesSubject.asObservable() | async"
    [filteredPayrollItemsSelectItems]="filteredPayrollItemsSelectItems$ | async"
    [usersFilterSelectItems]="UsersSubject.asObservable() | async"
    [directReportsSelectItems]="directReportsSelectItems$ | async"
    [activeDirectReportsSelectItems]="activeDirectReportsSelectItems$ | async"
    [startDatesSelectItems]="startDatesSelectItems$ | async"
    [endDatesSelectItems]="endDatesSelectItems$ | async"
    [payperiodSelectItems]="payperiodSelectItems$ | async"
    [StartDate]="StartDate$ | async"
    [EndDate]="EndDate$ | async"
    (Filter)="onFilter($event)"
    (Save)="onSave($event)"
    (Delete)="onDelete($event)"
    (ShowError)="onShowError($event)"
    (ClearStatus)="onClearStatus()"
    (SelectDirectReport)="SelectDirectReportSubject.next($event)"
    (RecalcRates)="onRecalcRates($event)"
></ef-payrate-override>
